// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1hM8e","title":"FrontImage_title__2M4Oa"};